<video class="videots-player" #videoTSPlayer></video>
